import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { EquivalentData } from './equivalent.model';
import { EquivalentService } from './equivalent.service';

export class EquivalentDataSource implements DataSource<EquivalentData> {

  private dataSubject = new BehaviorSubject<EquivalentData[]>([]);
  private dataLengthSubject = new BehaviorSubject<number>(0);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public data = this.dataSubject.asObservable();
  public dataLength = this.dataLengthSubject.asObservable();
  public loading = this.loadingSubject.asObservable();

  constructor(private equivalentService: EquivalentService) {}

  connect(collectionViewer: CollectionViewer): Observable<EquivalentData[]> {
    return this.dataSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.dataSubject.complete();
    this.loadingSubject.complete();
  }

  loadEquivalents(
    pageIndex: number,
    pageSize: number,
    sortBy: string = 'createdAt',
    sortDirection: string = 'asc',
    filter: string = '',
  ) {

    this.loadingSubject.next(true);

    this.equivalentService
      .findPaginated(
        pageIndex,
        pageSize,
        sortBy,
        sortDirection,
        filter
      )
      .pipe(
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(data => {
        this.dataSubject.next(data._embedded.equivalent);
        this.dataLengthSubject.next(data.total_items);
      });
  }
}
